import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Tab,
  TabList,
  TabPanel,
  Tabs,
} from '../../../../../components/tabs/DoctrineTabs';
import { EnterpriseSnippetFetcher } from './EnterpriseSnippetFetcher';
import { EvolutionTab } from './EvolutionTab';
import { JuridictionTab } from './JuridictionTab';
import { VilleTab } from './VilleTab';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';

type Props = {
  enterpriseId: string;
  siren: string;
  raisonSociale: string;
  url: string;
  source: string;
};

export class EnterpriseSnippetTabs extends React.Component<Props> {
  onSelect = (index: number, last: number, event: Event) => {
    const { source } = this.props;
    doctrineAnalytics('SnippetTabClicked', {
      button: (event.target as HTMLElement).innerText,
      type: 'Enterprise',
      source,
      reportOriginalQueryKey: true,
    });
  };

  render() {
    const { enterpriseId, siren, raisonSociale, url, source } = this.props;
    return (
      <EnterpriseSnippetFetcher siren={siren}>
        {({ juridictions, villes, caseData }) =>
          juridictions.length > 0 || villes.length > 0 || caseData ? (
            <Tabs onSelect={this.onSelect}>
              <TabList>
                {juridictions.length > 0 && (
                  <Tab>
                    <div className="tabs-label">
                      <FormattedMessage id="search/components/search-snippets/aside/enterprise/EnterpriseSnippetTabs.tsx/1" />
                    </div>
                  </Tab>
                )}
                {villes.length > 0 && (
                  <Tab>
                    <div className="tabs-label">
                      <FormattedMessage id="search/components/search-snippets/aside/enterprise/EnterpriseSnippetTabs.tsx/2" />
                    </div>
                  </Tab>
                )}
                {caseData && (
                  <Tab>
                    <div className="tabs-label">
                      <FormattedMessage id="search/components/search-snippets/aside/enterprise/EnterpriseSnippetTabs.tsx/3" />
                    </div>
                  </Tab>
                )}
              </TabList>
              {juridictions.length > 0 && (
                <TabPanel>
                  <JuridictionTab
                    juridictions={juridictions}
                    url={url}
                    source={source}
                    enterpriseId={enterpriseId}
                    raisonSociale={raisonSociale}
                  />
                </TabPanel>
              )}
              {villes.length > 0 && (
                <TabPanel>
                  <VilleTab
                    villes={villes}
                    url={url}
                    source={source}
                    enterpriseId={enterpriseId}
                    raisonSociale={raisonSociale}
                  />
                </TabPanel>
              )}
              {caseData && (
                <TabPanel>
                  <EvolutionTab
                    enterpriseDatas={{
                      enterpriseId,
                      siren,
                      raisonSociale,
                      chronology: {
                        caseData,
                      },
                    }}
                    source={source}
                  />
                </TabPanel>
              )}
            </Tabs>
          ) : null
        }
      </EnterpriseSnippetFetcher>
    );
  }
}
